import { sapApi } from "@/apis/interceptor"
import { IGetEmployeeByIdParams, IResponse, ISapReservation, ISapReservationDto, ISapReservationResponseData } from "@/types"

export const sapReservationsService = {
  getSapReservations: async (params: IGetEmployeeByIdParams): Promise<IResponse<ISapReservationResponseData>> => {
    const response = await sapApi.get<IResponse<ISapReservationResponseData>>("/api/v1/reservations/history", { params })
    return response.data
  },

  getSapReservationByRecordId: async (recordId: string): Promise<IResponse<ISapReservation>> => {
    const response = await sapApi.get<IResponse<ISapReservation>>(`/api/v1/reservations/${recordId}`)
    return response.data
  },

  createSapReservation: async (dto: ISapReservationDto): Promise<IResponse<ISapReservation>> => {
    const response = await sapApi.post<IResponse<ISapReservation>>("/api/v1/reservations", dto)
    return response.data
  },
}
